import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBarSelection from '../pages/selection/TopBarSelection';
import './SelectionLayout.css'; // تنسيقات خاصة بصفحات الاختيار
const currentYear = new Date().getFullYear();

function SelectionLayout() {
  return (

    <div className="selection-container">
      <TopBarSelection />
      <main className="selection-content">
        <div className="selection-card-wrapper">
          <Outlet /> {/* هنا ستظهر صفحة اختيار الأرض أو المحصول */}
          <div className="footer-bottom">
            <p >
              حالياً في مرحلة التطوير، ترقبوا المزيد من الميزات قريباً!
              <br />
              © {currentYear} <strong>ديوان الأرض</strong>. كل الحقوق محفوظة.
              <br />
              برمجة وتصميم: <strong>محمد سلامة</strong> |
              فكرة ومحتوى ومسؤول عن التطوير والإدارة الرقمية: <strong>عبدالله جابر</strong> و <strong>محمد سلامة</strong>
            </p>
          </div>
        </div>
      </main>
    </div>

  );
}

export default SelectionLayout;